let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7gKdX")).then(() => parcelRequire('kO3mB'));